/* eslint-disable no-console */

import { register } from 'register-service-worker';

function cleanCache() {
  caches.keys().then(cacheNames => {
    cacheNames.forEach(cacheName => {
      caches.delete(cacheName);
    });
  });
}

// if (process.env.NODE_ENV === 'production') {
register(`${process.env.BASE_URL}service-worker.js`, {
  registrationOptions: {
    updateViaCache: 'none'
  },
  ready(registration) {
    console.log('Ready');
    console.log(registration)
  },
  registered() {
    console.log('Registered');
    cleanCache();
  },
  cached() {
    console.log('Cached');
  },
  updatefound() {
    console.log('Update Found');
    cleanCache();
  },
  updated() {
    console.log('Updated');
  },
  offline() {
    console.log('Offline');
  },
  error(error) {
    console.warn('Error:', error);
    cleanCache();
  }
})
// }
